import React from 'react'
import {Typography} from '@material-ui/core'
import {PieChart, ResponsiveContainer, Pie, Cell} from 'recharts'
import {makeStyles} from '@material-ui/styles'
import {isUndefined} from 'lodash'
import Dougnut from './Doughnut'

const useStyles = makeStyles(theme => ({
    ofLabel: {
        position: 'absolute',
        right: 7,
        bottom: 3
    }
}))

  const data02 = [
    {
      "name": "Group A",
      "value": 2400
    },
  ];
  

export default function Donut({mainTitle, subTitle, fvalue, increase, fofValue, ofValue, value, intervalFunction}) {
    const classes = useStyles()

    React.useEffect(() => {
        if(!isUndefined(intervalFunction)) {
            intervalFunction()
            let id = setInterval(() => {
                intervalFunction();
            }, 30000);
            return () => clearInterval(id);
        }
    }, []);

    const createData = () => {
        //this.props.MonthVunnen >= this.props.Budget?100:this.props.MonthVunnen

        const bPercent = ((ofValue - value) / ofValue) * 100
        const vPercent = ((value) / ofValue) * 100

        return [
            { name: 'Vunnen', value: value >= ofValue?100: vPercent, color:'#009688'},
            { name: 'Budget', value: value >= ofValue?0:bPercent, color:'#ededed'},
        ]
    }

    return (
        <div className="h-100 d-flex align-items-center justify-content-between px-3 py-2 postition-relative">
            <div>
                <h3 className="mb-0">{mainTitle}</h3>
                <p>{subTitle}</p>
                <Typography component="h1" color="primary" style={{fontWeight: 500, fontSize:24}}>{fvalue}</Typography>
            </div>
              <Dougnut totalVarde={ofValue} value={value}/>
                {/* <ResponsiveContainer width={120} height="100%">
                    <PieChart> 
                        <Pie startAngle={-270} data={createData()} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={'65%'} outerRadius={'95%'} fill="#ededed">
                            {
                                createData().map((d,i) => <Cell key={i} fill={d.color}/>)
                            }
                            </Pie>
                    </PieChart>
                </ResponsiveContainer> */}
                {
                    !isUndefined(fofValue) && (<span className={classes.ofLabel}>{`/ ${fofValue}`}</span>)
                }
                
        </div>
    )
}
